import { render, staticRenderFns } from "./RequestListView.vue?vue&type=template&id=37a45537"
import script from "./RequestListView.vue?vue&type=script&lang=js"
export * from "./RequestListView.vue?vue&type=script&lang=js"
import style0 from "./RequestListView.vue?vue&type=style&index=0&id=37a45537&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports